<div>
  <app-rec-plan-plannum-search-header [recordCount]="recPlanNumResults.recordCount"></app-rec-plan-plannum-search-header>
</div>
<div>
  <app-rec-plan-plannum-search-grid></app-rec-plan-plannum-search-grid>
</div>
